define('collections/distributors',['require','collections/base','models/distributor'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/distributor");

    return BaseCollection.extend({
        model: Model,
        url: 'distributors.json'
    });
});

